const THRESHOLDS = [100, 75, 50, 25] as const

let handleScroll: ReturnType<typeof useDebounceFn>

export default defineNuxtRouteMiddleware((to) => {
  if (isServer()) return

  let highestFiredThreshold = 0
  const { trackEvent } = useOptimizely()

  if (!handleScroll) {
    handleScroll = useDebounceFn(() => {
      const pageHeight = document.documentElement.scrollHeight - window.innerHeight

      const scrollPosition = window.scrollY || document.documentElement.scrollTop
      const scrollPercentage = (scrollPosition / pageHeight) * 100

      for (const threshold of THRESHOLDS) {
        if (scrollPercentage >= threshold && threshold > highestFiredThreshold) {
          trackEvent('pageScroll', { percentage: threshold })
          // We only want to fire once per threshold on given page
          highestFiredThreshold = threshold
          break
        }
      }
    }, 50)
  }

  // resetting listener when entering page
  document.removeEventListener('scroll', handleScroll)
  const visitedPaths = useSessionStorage<string[]>('opti-scr-vp', [], { serializer: { read: JSON.parse, write: JSON.stringify } })
  // track just once per session on given page, on consecutive visits - ignore
  if (visitedPaths.value.includes(to.path)) return

  document.addEventListener('scroll', handleScroll)
  visitedPaths.value.push(to.path)
})
